<template>
    <div class="page_card" v-loading="!is_ok">
        <el-card style="margin-right: 10px">
            <div slot="header" class="clearfix">
                <span>当前计划单<span class="primary_text" style="font-size: 14px" v-if="data.length">共 {{data.length}} 条计划单</span></span>
            </div>
            <el-form :model="selectForm" ref="selectForm" inline>
                <el-form-item label="企业名称/简称">
                    <el-select
                        v-model="selectForm.comId"
                        :multiple="false"
                        filterable
                        remote
                        reserve-keyword
                        placeholder="请输入企业名称/简称"
                        @change="changeCom"
                        :loading="is_select">
                        <el-option
                            v-for="item in componys"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="产品">
                    <el-select v-model="selectForm.goodsId" placeholder="请选择">
                        <el-option :label="item.name" :class="{primary_text:item.isMain && item.isMain == 1}" :value="item.id" v-for="item of goods_list" :key="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="计划编号">
                    <el-input v-model="selectForm.orderSn" placeholder="请输入计划编号"></el-input>
                </el-form-item>
                <el-form-item label="驾驶员">
                    <el-input v-model="selectForm.driverName" placeholder="请输入驾驶员"></el-input>
                </el-form-item>
                <el-form-item label="驾驶员电话">
                    <el-input v-model="selectForm.driverMobile" placeholder="请输入驾驶员电话"></el-input>
                </el-form-item>
                <el-form-item label="主车号">
                    <el-input v-model="selectForm.plateNumber" placeholder="请输入主车号"></el-input>
                </el-form-item>
                <el-form-item label="挂车号">
                    <el-input v-model="selectForm.carriageNumber" placeholder="请输入挂车号"></el-input>
                </el-form-item>
                <el-form-item label="计划单状态">
                    <el-select v-model="selectForm.status" placeholder="请选择">
                        <el-option v-for="(item,index) in statuType" :key="index" :label="item.lb" :value="item.vl"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="日期">
                    <el-select v-model="selectForm.planDate" placeholder="请选择">
                        <el-option label="全部" value="0"></el-option>
                        <el-option label="今天" value="1"></el-option>
                        <el-option label="明天" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="计划日期排序">
                    <el-radio v-model="selectForm.sortType" label="asc">升序</el-radio>
                    <el-radio v-model="selectForm.sortType" label="desc">降序</el-radio>
                </el-form-item> -->
                <el-form-item label="">
                    <el-button plain type="primary" @click="selectSubmit()" :loading="is_post">查 询</el-button>
                    <el-button plain @click="resetSelect()" :loading="is_post">重 置</el-button>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="success" plain @click="goToAdd" v-can="['btn:customer_add_plan']"> + 新增计划单</el-button>
                    <!-- <el-button type="warning" plain @click="changePrice" v-can="['btn:change_price']" :disabled="checked.length == 0"><svg-icon icon-class="price" /> 批量调价({{checked.length}})</el-button> -->
                </el-form-item>
                <el-form-item >
                    <el-button type="warning" plain icon="el-icon-download" @click="downloadExcel">下载计划单模板</el-button>
                </el-form-item>
                <el-form-item >
                    <el-button type="warning" plain :icon="uploadBtnIcon" @click="clickUpload" >导入计划单</el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <el-row style="margin-top: 20px;margin-right: 10px;" v-loading="is_loading">
            <el-table
                ref="table"
                :data="data"
                class="history_table"
                v-loading="is_loading"
                tooltip-effect="dark"
                style="padding:0 20px;"
                :default-sort = "{prop: 'createTime', order: 'descending'}"
                >

                <el-table-column label="计划编号" width="180" >
                    <template slot-scope="scope">
                    <el-link
                        :underline="false"
                        @click="goToDetail(scope.row.id)"
                        type="primary"

                        >{{ scope.row.orderSn }}</el-link
                    >
                    </template>
                </el-table-column>
                <el-table-column label="企业名称" width="200">
                    <template slot-scope="scope">
                    <span class="primary_text">{{ scope.row.comName }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="产品" width="70" >
                    <template slot-scope="scope">
                    <span class="success_text">{{ scope.row.goodsName }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="计划日期" width="120" >
                    <template slot-scope="scope">
                    {{ scope.row.planDate }}
                    </template>
                </el-table-column>
                <el-table-column label="计划单状态" width="100" >
                    <template slot-scope="scope">
                    <el-tag :type="statusType(scope.row.status)">{{
                        parseStatus(scope.row.status)
                    }}</el-tag>
                    </template>
                </el-table-column>

                <el-table-column label="挂牌价" width="120">
                    <template slot-scope="scope">
                    <span class="warning_text">{{parseNums(scope.row.price)}} 元/吨</span>
                    </template>
                </el-table-column>


                <el-table-column label="主车号" width="100" >
                    <template slot-scope="scope">
                    <span>{{ scope.row.plateNumber }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="挂车号"
                    width="100"

                >
                    <template slot-scope="scope">
                    <span>{{ scope.row.carriageNumber }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="驾驶员" width="100">
                    <template slot-scope="scope">
                    <span>{{ scope.row.driverName }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="驾驶员电话"
                    width="110"
                >
                    <template slot-scope="scope">
                    <span>{{ scope.row.driverMobile }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="创建时间"
                    width="160"
                    prop="addTime"
                    sortable
                >
                    <template slot-scope="scope">
                    {{ scope.row.addTime }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="180">
                    <template slot-scope="scope">
                        <div class="btn-box" style="display: flex;justify-content: center;">
                            <el-button
                                size="mini"
                                type="info"
                                class="btnBh"
                                style="padding:5px;margin-bottom: 5px;"
                                v-can="['btn:customer_modifies_basic_information']"
                                :disabled="is_post"
                                @click="goToDetail(scope.row,'edit')"
                                plain>修改基本信息
                            </el-button>
                            <el-button
                            size="mini"
                            type="info"
                            v-can="['btn:cancel_schedule']"
                            style="padding:5px;margin-bottom: 5px;"
                            @click="goCancelPlan(scope.row.id)"
                            >取消计划单</el-button
                            >

                        </div>
                    </template>
                </el-table-column>
            </el-table>


        </el-row>
        <!-- <el-row style="margin-top: 20px" v-loading="is_loading">
            <div v-if="data.length == 0">
                <div style="display: flex;align-items: center;justify-content: center;flex-direction:column;">
                    <svg-icon style="font-size: 180px" icon-class="no_order" />
                    <div style="color: #aaa">
                        暂无计划单
                    </div>
                </div>
            </div>
            <template v-else>
                <el-card :class="checked.includes(item.id)?'order_item active':'order_item'" shadow="hover" v-for="(item,index) of data" :key="item.id">
                    <div class="item_body" @click="checkItem(item,index)">
                        <el-row class="item_header">
                            <div style="float:left">
                                <span style="display: inline-block;margin-right: 10px;font-size: 18px;" class="success_text">LNG</span>
                                <span style="display: inline-block;margin-right: 20px;font-size: 18px;font-weight: 700" >{{item.comName}}</span>
                                <span class="ptext">{{item.date}}</span>
                            </div>
                            <div class="btns">
                                <el-tooltip effect="light" content="计划单详情" placement="top-start">
                                <span style="display: inline-block" @click.stop="goToDetail(item.id)">
                                    <el-avatar size="large" shape="circle" class="item_btn" @click="goToAdd"><svg-icon icon-class="component" /></el-avatar>
                                </span>
                                </el-tooltip>

                                <el-tooltip effect="light" content="修改基本信息" placement="top-start" v-can="['btn:customer_modifies_basic_information']">
                                <span style="display: inline-block" @click.stop="goToDetail(item,'edit')">
                                    <el-avatar size="large" shape="circle" class="item_btn"><svg-icon icon-class="edit" /></el-avatar>
                                </span>
                                </el-tooltip>
                                <el-tooltip effect="light" content="取消计划单" v-can="['btn:cancel_schedule']" placement="top-start" v-if="parseStatus(item.status)=='待审核'||parseStatus(item.status)=='已审核'||parseStatus(item.status)=='已打卡'||parseStatus(item.status)=='已登记'||parseStatus(item.status)=='入厂安检'">
                                <span style="display: inline-block" @click.stop="goCancelPlan(item.id)">
                                    <el-avatar size="large" shape="circle" class="item_btn_cancel"><svg-icon icon-class="del" /></el-avatar>
                                </span>
                                </el-tooltip>
                            </div>
                        </el-row>
                        <el-row style="width: 100%;margin: 25px 20px 10px 20px">
                              <div class="item_item ptext">
                                计划日期: {{item.planDate}}
                            </div>
                            <div class="item_item ptext">
                                主车号: {{item.plateNumber}}
                            </div>
                            <div class="item_item ptext">
                                挂车号: {{item.carriageNumber}}
                            </div>
                            <div class="item_item ptext">
                                驾驶员: {{item.driverName}}
                            </div>
                            <div class="item_item ptext">
                                驾驶员电话: {{item.driverMobile}}
                            </div>
                            <div class="item_item ptext">
                                物流公司: {{item.expressName}}
                            </div>
                             <div class="item_item ptext">
                                LNG挂牌价: {{parseNums(item.price)}}
                            </div>
                            <div class="item_item ptext">
                                计划单状态: {{parseStatus(item.status)}}
                            </div>
                             <div class="item_item ptext">
                                备注: {{item.remark}}
                            </div>
                        </el-row>
                    </div>
                    <div class="item_footer">
                        <div style="float: left">
                        </div>
                        <div style="float: right">
                            <span class="ptext">总价: <span class="info_text" style="font-size: 18px">￥ {{parseNums(item.planAmount)}} 元</span></span>
                        </div>
                    </div>
                </el-card>
            </template>
        </el-row> -->

        <el-dialog :title="is_add ?'添加计划':'修改计划'" :visible.sync="add_dialog" width="30%" @close="close">
                  <div v-if='is_add' class="view_section_right_view" @click="onButtonClick">
                    智能识别
                  </div>
                  <el-form label-position="center" ref="addForm" :rules="Rules" label-width="100px" :model="addForm" style="padding: 0 20px;">
                           <el-form-item label="计划日期" prop="date" >
                                <el-select v-model="addForm.date" :disabled="!is_add" placeholder="请选择装液日期" style="width:100%">
                                    <el-option
                                        v-for="item in dates"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                             <el-form-item label="主车号" prop="plateNumber">
                                <el-input v-model="addForm.plateNumber" @input="plateNumberInput" placeholder="请输入装液主车号: 宁A12L45" maxlength="7" show-word-limit></el-input>
                           </el-form-item>
                         <el-form-item label="挂车号" prop="carriageNumber">
                              <el-input v-model="addForm.carriageNumber" @input="carriageNumberInput" placeholder="请输入装液挂车号: 宁A1234挂" maxlength="7" show-word-limit></el-input>
                        </el-form-item>
                         <el-form-item label="驾驶员" prop="driverName">
                              <el-input v-model="addForm.driverName" placeholder="请输入驾驶员" maxlength="10" show-word-limit></el-input>
                        </el-form-item>
                        <el-form-item label="驾驶员电话" prop="driverMobile">
                              <el-input v-model="addForm.driverMobile" placeholder="请输入驾驶员电话" maxlength="11" show-word-limit></el-input>
                        </el-form-item>
                      <el-form-item label="押运员" prop="escortName">
                              <el-input v-model="addForm.escortName" placeholder="请输入驾驶员" maxlength="10" show-word-limit></el-input>
                        </el-form-item>
                        <el-form-item label="押运员电话" prop="escortMobile">
                              <el-input v-model="addForm.escortMobile" placeholder="请输入驾驶员电话" maxlength="11" show-word-limit></el-input>
                        </el-form-item>
                         <el-form-item label="产品" prop="goodsName">
                                <el-select v-model="addForm.goodsName" placeholder="请选择订购的产品" @change="goodsChange" style="width:100%">
                                    <el-option
                                        :class="{primary_text:item.isMain == 1}"
                                        v-for="item in goods_list"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                        <span style="float: left">{{ item.name }}</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.price }}元/吨</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        <el-form-item label="物流公司">
                              <el-autocomplete
                                    style="width: 100%"
                                    class="inline-input"
                                    v-model="addForm.expressName"
                                    :fetch-suggestions="querySearchExpressName"
                                    placeholder="请输入物流公司名称"
                                    :trigger-on-focus="false"
                                    :maxlength="20"
                                    show-word-limit
                              ></el-autocomplete>
                        </el-form-item>
                        <!-- <el-form-item label="价格">
                              <el-input v-model="addForm.realPrice" disabled></el-input>
                        </el-form-item> -->
                        <el-form-item label="备注">
                              <el-input placeholder="备注" v-model="addForm.remark" :autosize="{ minRows:4, maxRows:6}" maxlength="200" show-word-limit type="textarea"></el-input>
                        </el-form-item>
                        <el-form-item label="" v-if='is_add'>
                              <el-button plain type="primary" @click="addSubmit()">保 存</el-button>
                              <el-button plain @click="addSelect()">重 置</el-button>
                        </el-form-item>
                        <el-form-item v-else>
                             <el-button type="warning" plain :loading="is_post" @click="editSubmit">提交修改</el-button>
                        </el-form-item>
                  </el-form>
           </el-dialog>

        <el-dialog :title="is_many?'批量调价':'调价'" :visible.sync="edit_price_dialog" width="25%">
            <el-alert show-icon title="注意" :closable="false" description="最终价格 = 实际价格 - 长期优惠 - 销售员优惠" type="warning" style="margin-bottom: 20px"></el-alert>
            <el-form :model="priceForm" ref="priceForm" :rules="priceRules" label-width="120px">
                <el-form-item label="实际价格(元/吨)" prop="realPrice">
                    <el-input v-model="priceForm.realPrice" placeholder="请输入实际价格"></el-input>
                </el-form-item>
                <el-form-item label="销售员优惠(元/吨)" prop="saleCutPrice">
                    <el-input v-model="priceForm.saleCutPrice" placeholder="请输入销售员优惠额"></el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-button plain type="primary" :loading="is_post" @click="submitPriceChange">提 交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog title="模拟称重" :visible.sync="setWeightDialog" width="25%">
            <el-form :model="weightForm" ref="weightForm" label-width="120px">
                <el-form-item label="地磅号">
                    <el-input type="number" placeholder="输入地磅号 1-6" v-model="weightForm.weighterNo"></el-input>
                </el-form-item>
                <el-form-item label="重量(kg)">
                    <el-input type="text" placeholder="输入重量 以千克为单位" v-model="weightForm.weightValue"></el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" plain :loading="is_post" @click="setWeightSubmit">提 交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog title="模拟铅封" :visible.sync="setLeadDialog" width="25%">
            <el-form :model="leadForm" ref="weightForm" label-width="120px">
                <el-form-item label="铅封号">
                    <el-input type="text" placeholder="输入铅封号" v-model="leadForm.leadSealNo"></el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" plain :loading="is_post" @click="setLeadSubmit">提 交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog title="智能识别" :visible.sync="is_smart" width="35%" @close='handleCancle'>
            <div class="box">
                <div class="box-title">
                    <span>智能输入短信信息</span>
                </div>
                <div>
                    <el-input v-model="inputVal" @input="smartInput" @change="btnInput" class="textarea-box" :autosize="{ minRows: 6, maxRows: 12}" placeholder-class="remark-box" type="textarea" maxlength="50000"  placeholder="请输入需要识别的内容，每条信息之间用#号隔开，例：车牌号：XXXXXX 车挂号：XXXXXX挂 司机:XXX 手机号：1XXXXXXXXXXX 押运员:XXX 手机号:1XXXXXXXXXXX"></el-input>
                </div>
                <div class="btn-box">
                    <div @click="resetBtn" class="btn-common btn-reset">清空</div>
                    <div @click="btnClick" class="btn-common btn-identify">识别</div>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="智能识别列表" :visible.sync="is_smart_list" width="35%" @close='handleCancleList'>
            <div v-for="item in orderList" :key="item.id"  class="order-list">
                <div @click="btnClickList(item.orderData)" class="order-text">{{item.name}}</div>
            </div>
        </el-dialog>
        <el-dialog title="导入计划单" :visible.sync="uploadDialog" width="30%">
            <el-form :model="uploadForm" ref="uploadForm" label-width="120px">
                <el-form-item label="选择产品" prop="good">
                    <el-select v-model="uploadForm.good" placeholder="请选择产品" style="width:100%">
                        <el-option
                            v-for="item in goods_list"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="计划日期" prop="planDate">
                    <el-select v-model="uploadForm.planDate" placeholder="请选择计划日期" style="width:100%">
                        <el-option
                            v-for="item in dates"
                            :key="item"
                            :label="item"
                            :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item style="margin-top:25px;">
                <el-button type="primary" ref="updataButt" plain :icon="uploadBtnIcon" @click="clickSubmit">导入计划单</el-button >
                <el-upload
                        multiple
                        ref="upload"
                        v-loading="uploadLoading"
                        :show-file-list="false"
                        accept=".xls,.xlsx"
                        :limit="limitNum"
                        action="baseUrl"
                        :before-upload="beforeAvatarUploadPDF"
                        :http-request="uploadFile"
                        :on-success="fileUploadSuccess"
                        :on-error="fileUploadError"
                        :disabled="fileUploadBtnText == '正在导入'"
                        style="display: inline; margin-left: 10px"
                >
                </el-upload>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>

import request from '@/utils/request'
import {deepClone,parseTime} from '@/utils'
import can from "@/directive/can/index.js"
import {mapGetters} from 'vuex'
import {stringTrim} from '@/utils/elvalid'
export default {
    name: 'order_list',
    computed:{
        ...mapGetters([
            'permissions'
        ])
    },
    directives:{can},
    data(){
        let validate_cut_price = (rule, value, callback)=>{
            if(parseFloat(value) >= parseFloat(this.priceForm.realPrice)){
                callback(new Error("优惠不能大于价格!"));
            }else{
                callback();
            }
        }
        return {
            setWeightDialog:false,
            fileUploadBtnText: "导入计划单",
            uploadBtnIcon: "el-icon-upload2",
            is_smart:false,
            uploadDialog:false,
            inputVal:'',
            limitNum: 1,
            newInputList:[],
            is_smart_list:false,
            orderList:[],
            orderListDetail:[],
            weightForm:{
                orderSn:"",
                weighterNo:"",
                weightValue:""
            },
            uploadForm: {
                planDate: "",
                good:null
            },
            statuType:[
                {lb:'待审核',vl:0},
                {lb:'已审核',vl:10},
                {lb:'已打卡',vl:15},
                {lb:'入厂安检',vl:21},
                {lb:'一次过磅',vl:23},
                {lb:'已充装',vl:24},
                {lb:'出厂安检',vl:26},
                {lb:'二次过磅',vl:27}
            ],
            setLeadDialog:false,
            leadForm:{
                orderSn:"",
                leadSealNo:""
            },
             addForm:{
                  carriageNumber:'',
                  goodsId:'',
                  goodsName:'',
                  expressName:'',
                  date:'',
                  driverMobile:'',
                  driverName:'',
                  plateNumber:"",
                  realPrice:'',
                  remark:""
            },
            dates:[],
            is_add:false,
            add_dialog:false,
            is_ok:false,
            is_loading:false,
            is_post:false,
            is_select:false,
            data:[],
            total:0,
            com_id:0,
            selectForm:{
                goodsId:"",
                orderSn:"",
                comId:"",
                plateNumber:"",
                driverName:"",
                driverMobile:"",
                carriageNumber:"",
                status:"",
                planDate:'0',
                // sortType:"desc"
            },
            componys:[],
            checked:[],
            edit_dialog:false,
            edit_price_dialog:false,
            priceForm:{
                ids:[],
                realPrice:"",
                saleCutPrice:""
            },
            Rules:{
                carriageNumber:[
                        {required: true, message: '请输入挂车号', trigger: 'blur'},
                        {pattern:/^[京津晋冀蒙辽吉黑沪苏浙皖闽赣鲁豫鄂湘粤桂琼渝川贵云藏陕甘青宁新][ABCDEFGHJKLMNPQRSTUVWXY][\dA-Z]{4}挂$/,message:"请输入正确的挂车号",trigger: 'blur'}
                ],
                date:[
                        {required: true, message: '请选择日期', trigger: 'blur'},
                ],
                driverMobile:[
                        {required: true, message: '请输入驾驶员电话', trigger: 'blur'},
                        {pattern:/^1[345789]\d{9}$/,message:"请输入正确的驾驶员电话",trigger: 'blur'}
                ],
                driverName:[
                    {required: true, message: '请输入驾驶员', trigger: 'blur'},
                    { validator: stringTrim, trigger: 'blur' }
                ],
                plateNumber:[
                        {required: true, message: '请输入主车号', trigger: 'blur'},
                        {pattern:/^[京津晋冀蒙辽吉黑沪苏浙皖闽赣鲁豫鄂湘粤桂琼渝川贵云藏陕甘青宁新][ABCDEFGHJKLMNPQRSTUVWXY][\dABCDEFGHJKLNMxPQRSTUVWXYZ]{5}$/,message:"请输入正确的主车号",trigger: 'blur'}
                ],
                goodsId:[
                    {required: true, message: '请选择一个产品', trigger: 'change'}
                ]
            },
            priceRules:{
                realPrice:[
                    { required: true, message: '请输入实际价格', trigger: 'blur' },
                    {pattern:/^([1-9]\d*(\.\d{1,2})?|[0]{1}\.\d{1,2})$/,message:"请输入一个数字,最多保留2位小数",trigger: 'blur'}
                ],
                saleCutPrice:[
                    { required: true, message: '请输入销售优惠', trigger: 'blur' },
                    {pattern:/^([1-9]\d*(\.\d{1,2})?|[0]{1}\.\d{1,2}|0)$/,message:"请输入一个数字,最多保留2位小数",trigger: 'blur'},
                    { validator: validate_cut_price, trigger: 'blur' }
                ]
            },
            is_many:false,
            goods_list:[],
            active_item:null,
            uploadLoading:false,
        }
    },
    methods:{
        plateNumberInput(e){
            this.addForm.plateNumber = e.toUpperCase();
        },
        carriageNumberInput(e){
            this.addForm.carriageNumber = e.toUpperCase();
        },
        clickSubmit(){
            if(this.uploadForm.planDate==''){
                this.$message.error("请先选择计划日期！");
            }else{
                this.$refs['upload'].$refs['upload-inner'].handleClick()
            }
        },
        beforeAvatarUploadPDF(){
            this.$refs.upload.clearFiles();
        },
        uploadFile(item) {
            this.uploadLoading=true;
            let formData = new FormData();
            formData.append("excel", item.file);
            formData.append("planDate",this.uploadForm.planDate);
            formData.append("good",this.uploadForm.good);
            request.post("order/client_import", formData).then((res) => {
                if (res.code == 200) {
                this.getData(true);
                this.uploadLoading=false;
                this.uploadDialog=false;
                this.uploadForm.planDate='';
                this.uploadForm.good=null;
                this.$message.success("数据导入成功！");
                } else {
                this.uploadLoading=false;
                this.uploadDialog=false;
                this.uploadForm.planDate='';
                this.$message.error("数据导入失败！");
                }
            });
        },
        fileUploadSuccess() {
            this.enabledUploadBtn = true;
            this.uploadBtnIcon = "el-icon-upload2";
            this.fileUploadBtnText = "导入计划单";
            this.$message.success("数据导入成功！");
        },
        fileUploadError() {
            this.enabledUploadBtn = true;
            this.uploadBtnIcon = "el-icon-upload2";
            this.fileUploadBtnText = "导入计划单";
        },
        async downloadExcel() {
            window.location.href ="https://jbxy-lng-bucket.oss-cn-beijing.aliyuncs.com/excel_template/client_template.xlsx";
        },
        clickUpload(){
            this.uploadDialog=true;
        },

        parseNums(n,is_int=false) {
            //转化成字符串
            let str = n.toString();
            //若是整数自动补全小数位
            if (-1 == str.indexOf(".")) {
                str = str + ".00"
            }
            if(str.indexOf(".")!=-1){
                let x = str.indexOf('.') + 1;   //小数点的位置
                let y = str.length - x;  //小数的位数
                if(y > 0 && y == 1){
                    str = str + "0"
                }
            }
            //全部替换
            if (-1 != str.indexOf(",")) {
                str = str.replace(new RegExp(',', "g"), "")
            }
            let intSum = str.substring(0, str.indexOf(".")).replace(/\B(?=(?:\d{3})+$)/g, ',');//取到整数部分
            if(is_int){
                return intSum;
            }
            let dot = str.substring(str.length, str.indexOf("."))//取到小数部分搜索
            let ret = intSum + dot;
            return ret;
        },
        //取消计划单
        goCancelPlan(id){
           this.$confirm('是否取消计划单?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                request.post("order/cancel",{id:id}).then(res=>{
                    this.$message.success("取消计划单成功");
                    this.getData();
                }).catch(err=>{
                    this.$message.error(res.msg);
                });

            });
        },
        onButtonClick() {
            this.is_smart=true;
        },
        handleCancle () {
            this.is_smart = false;
            this.inputVal='';
        },
        handleCancleList () {
            this.is_smart_list = false;
            this.orderList=[];
        },
        btnInput(e) {
            // this.inputVal=e;
        },
        smartInput(e){
            this.inputVal = e.toUpperCase()
        },
        resetBtn() {
            this.inputVal='';
        },
        //将汉字与英文、数字、下划线之间添加一个空格
        insert_spacing(str) {
            // var p1=/([1])([\u4e00-\u9fa5]+)/gi;
            var p2=/([\u4e00-\u9fa5]+)([1])/gi;
            return str.replace(p2, "$1 $2")
        },
        btnClick: function () {
            if(this.inputVal==''){
                this.$message.warning("识别内容不能为空！");
                return;
            }
            if(this.inputVal.indexOf("#") != -1){
            var inputList = this.inputVal.replace(/^(\s|#)+|(\s|#)+$/g, '').split("#");
            if(inputList.length<=1){
                this.getSingleData();
            }else{
                for(var i = 0; i < inputList.length; i++){
                var index;
                if(inputList[i].indexOf("：") != -1){
                    index = inputList[i].indexOf("：");
                }else if(inputList[i].indexOf("、") != -1){
                    index = inputList[i].indexOf("、");
                }
                var result = inputList[i].substr(index + 1,inputList[i].length);

                while(result.indexOf('-') != -1){
                    result=result.replace('-', ' ');
                }
                while(result.indexOf('司机:') != -1){
                    result=result.replace('司机:', ' ');
                }
                while(result.indexOf('司机') != -1){
                    result=result.replace('司机', ' ');
                }
                while(result.indexOf('押运员:') != -1){
                    result=result.replace('押运员:', ' ');
                }
                while(result.indexOf('电话') != -1){
                    result=result.replace('电话', ' ');
                }
                while(result.indexOf('手机号:') != -1){
                    result=result.replace('手机号:', ' ');
                }
                while(result.indexOf('手机号') != -1){
                    result=result.replace('手机号', ' ');
                }
                while(result.indexOf('身份证号码') != -1){
                    result=result.replace('身份证号码', ' ');
                }
                while(result.indexOf('身份证') != -1){
                    result=result.replace('身份证', ' ');
                }
                // 将汉字和数字中间添加空格
                inputList[i]=this.insert_spacing(result);
                var resultList=inputList[i].trim().split(/\s+/);
                inputList[i]=resultList;
                }
            }
            // 转换展示的新数组
            var newLists = [];
            inputList.forEach((el, index) => {
                var obj = {
                name: "订单"+(index + 1),
                orderData: el,
                };
                newLists.push(obj);
            });
            this.newInputList=newLists;

            //展示订单列表
            this.is_smart_list=true;
            this.orderList=this.newInputList

            }else{
                this.getSingleData();
            }
        },
        getSingleData:function(){
            var index;
            if(this.inputVal.indexOf("：") != -1){
             index = this.inputVal.indexOf("：");
            }else if(this.inputVal.indexOf("、") != -1){
             index = this.inputVal.indexOf("、");
            }
            var result = this.inputVal.substr(index + 1,this.inputVal.length);

            while(result.indexOf('-') != -1){
             result=result.replace('-', ' ');
            }
            while(result.indexOf('司机:') != -1){
             result=result.replace('司机:', ' ');
            }
            while(result.indexOf('司机') != -1){
             result=result.replace('司机', ' ');
            }
            while(result.indexOf('押运员:') != -1){
             result=result.replace('押运员:', ' ');
            }
            while(result.indexOf('电话') != -1){
             result=result.replace('电话', ' ');
            }
            while(result.indexOf('手机号:') != -1){
             result=result.replace('手机号:', ' ');
            }
            while(result.indexOf('手机号') != -1){
             result=result.replace('手机号', ' ');
            }
            while(result.indexOf('身份证号码') != -1){
             result=result.replace('身份证号码', ' ');
            }
            while(result.indexOf('身份证') != -1){
             result=result.replace('身份证', ' ');
            }
            // 将汉字和数字中间添加空格
            var lists=this.insert_spacing(result).trim().split(/\s+/);
            this.orderListDetail=lists;
            //关闭智能识别窗口
            this.is_smart=false;
            this.getInfoDetails();
        },
        getInfoDetails(){
            var countName=0;
            var countPhone=0;
            var countIdCard=0;
            for(let item of this.orderListDetail){
                let tempItem = item.toUpperCase()
                //车牌号验证
                if (/(^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[挂]{1}$)/.test(tempItem)) {
                    this.addForm.carriageNumber=tempItem;
                }
                if (/(^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9]{1}$)/.test(tempItem)) {
                    this.addForm.plateNumber=tempItem;
                }
            //姓名验证
            if (/^[\u4E00-\u9FA5A-Za-z]+$/.test(item)) {
                if(item.length<=6){
                    countName+=1;
                    if(countName==1){
                        this.addForm.driverName=item;
                    }else{
                        this.addForm.escortName=item;
                    }
                }
            }
            //手机号码验证：
            if (/^((13[0-9])|(14[0-9])|(15[0-9])|(17[0-9])|(18[0-9]))\d{8}$/.test(item)) {
                countPhone+=1;
                if(countPhone==1){
                 this.addForm.driverMobile=item;
                }else{
                  this.addForm.escortMobile=item;
                }
            }
            //身份证验证：
            if (/(\d{15}$)|(\d{18}$)|(^\d{17}(\d|X|x)$)/.test(item)) {
                countIdCard+=1;

                }
            }
        },
        parseNums(n,is_int=false) {
            //转化成字符串
            let str = n.toString();
            //若是整数自动补全小数位
            if (-1 == str.indexOf(".")) {
                str = str + ".00"
            }
            if(str.indexOf(".")!=-1){
                let x = str.indexOf('.') + 1;   //小数点的位置
                let y = str.length - x;  //小数的位数
                if(y > 0 && y == 1){
                    str = str + "0"
                }
            }
            //全部替换
            if (-1 != str.indexOf(",")) {
                str = str.replace(new RegExp(',', "g"), "")
            }
            let intSum = str.substring(0, str.indexOf(".")).replace(/\B(?=(?:\d{3})+$)/g, ',');//取到整数部分
            if(is_int){
                return intSum;
            }
            let dot = str.substring(str.length, str.indexOf("."))//取到小数部分搜索
            let ret = intSum + dot;
            return ret;
        },
        btnClickList(e){
            //关闭智能识别窗口
            this.is_smart_list=false;
            this.is_smart=false;
            this.orderListDetail=e;
            this.getInfoDetails();
        },
        resetSelect(){
            this.selectForm = {
                goodsId:"",
                orderSn:"",
                comId:"",
                plateNumber:"",
                driverName:"",
                driverMobile:"",
                carriageNumber:"",
                status:"all",
                // sortType:"desc"
            };
            this.$refs["selectForm"].resetFields();
            this.getData();
        },
        selectSubmit(){
            this.getData();
        },
         goodsChange(id){
            this.addForm.goodsId=id;
            request.get("goods/"+id).then(res=>{
                // this.form.realPrice = res.data.price;
                this.addForm.realPrice = res.data.price;
                if(res.data.isTemCut && res.data.temCutPrice){
                    this.form.temCut = res.data.temCutPrice;
                }else{
                    this.form.temCut = 0;
                }
                if(res.data.allowQuota){
                    this.form.saleCut = res.data.allowQuota;
                }else{
                    this.form.saleCut = 0;
                }
                this.activeGoods = res.data;
            }).catch(err=>{
                console.log(err);
            });
        },
        //批量调价
        changePrice(){
            this.priceForm.ids = deepClone(this.checked);
            this.priceForm.realPrice = "";
            this.priceForm.saleCutPrice = "";
            this.is_many = true;
            this.edit_price_dialog = true;
        },
        goToAdd(){
            this.add_dialog=true;
            this.is_add=true;
            this.lngPrice();
            //this.$router.push({name:"client_detail"});
        },
        has_permission(permission){
            return this.permissions.includes(permission);
        },
        goToDetail(item,type = false){
            if(type=='edit'){
                this.is_add=false;
                this.add_dialog=true;
                this.addForm.orderId=item.id;
                this.addForm.carriageNumber=item.carriageNumber,
                this.addForm.expressName=item.expressName,
                this.addForm.date=item.planDate,
                this.addForm.goodsId=item.goodsId,
                this.addForm.goodsName=item.goodsName,
                this.addForm.driverMobile=item.driverMobile,
                this.addForm.driverName=item.driverName,
                this.addForm.plateNumber=item.plateNumber,
                this.addForm.realPrice=item.realPrice,
                this.addForm.remark=item.remark
            }else{
                let id=item
                this.$router.push({name:"client_detail",params:{id}});
            }
        },
        getData(is_init = false){
            if(!is_init){
                this.is_loading = true;
                this.is_post = true;
            }
            request.post("order/client_curr_list",this.selectForm).then(res=>{
                this.data = res.data;
                if(!is_init){
                    this.is_loading = false;
                    this.is_post = false;
                }else{
                    this.is_ok = true;
                }
            }).catch(err=>{
                if(!is_init){
                    this.is_loading = false;
                    this.is_post = false;
                }else{
                    this.is_ok = true;
                }
            });
        },
        // selectComMethod(name){
        //     if(name.length > 1){
        //         this.is_select = true;
        //         request.get("company/option?keyword="+name).then(res=>{
        //             if(res.data && res.data.length > 0){
        //                 this.componys = res.data;
        //             }else{
        //                 this.componys = [];
        //             }
        //             this.is_select = false;
        //         }).catch(err=>{
        //             this.is_select = false;
        //         });
        //     }
        // },
        getCompany(){
            request.get("company/option").then(res=>{
                this.componys = res.data;
            }).catch(err=>{
            });
        },
        changeCom(e){
            this.selectForm.comId=e;
            this.getData();
        },
        parseStatus(num) {
            switch (num) {
            case 0:
                return "待审核";
            case 10:
                return "已审核"; //待打卡
            case 15:
                return "已打卡"; //待登记
            case 16:
                return "已登记"; //待入场安检
            case 21:
                return "入厂安检"; //待一次过磅
            case 23:
                return "一次过磅";//待充装
            case 24:
                return "已充装"; //待出厂安检
            case 26:
                return "出厂安检"; //待二次过磅
            case 27:
                return "二次过磅"; //待打印
            case 30:
                return "已完成"; //已打印
            case 90:
                return "客户取消";
            case 91:
                return "液厂取消";
            case 92:
                return "已过期";
            }
        },
        statusType(n){
            if(n < 10){
                return "warning";
            }else if(n >= 10 && n < 20){
                return "primary";
            }else if(n >= 20 && n <30){
                return "success";
            }
        },
        edit(item){
            this.active_item = item;
            this.edit_dialog = true;
        },
        editPrice(item){
            this.active_item = item;
            this.priceForm.realPrice = item.realPrice;
            this.priceForm.saleCutPrice = item.saleCut;
            this.priceForm.ids = [item.id];
            this.is_many = false;
            this.edit_price_dialog = true;
        },
        checkItem(item){
            console.log(item)
            if(this.checked.includes(item.id)){
                this.checked.map((it,i)=>{
                    if(it == item.id) this.checked.splice(i,1);
                });
            }else{
                this.checked.push(item.id);
            }
        },
        //提交价格修改
        submitPriceChange(){
            this.$refs["priceForm"].validate(valid=>{
                if(!valid) return false;
                this.is_post = true;
                request.post("order/com_edit_price",this.priceForm).then(res=>{
                    this.$message.success("调价操作成功!");
                    this.is_post = false;
                    this.getData();
                    this.edit_price_dialog = false;
                    this.$refs["priceForm"].resetFields();
                    this.priceForm = {
                        ids:[],
                        realPrice:"",
                        saleCutPrice:""
                    };
                }).catch(err=>{
                    this.is_post = false;
                });
            });
        },
        getcur(){
            request.get('/company/cus').then(res=>{
                if(res.code==200){
                    this.getGoodsList(res.data.id)
                }else{
                    this.$message.error(res.msg)
                }
            })
        },
        getGoodsList(id){
            request.get("goods/com_dropdown?com_id="+id).then(res=>{
                this.goods_list = this.goods_list.concat(res.data);
                this.addForm.goodsId=res.data[0].id
            }).catch(err=>{
                console.log(err);
            });
        },
        setWeight(item){
            this.active_item = item;
            this.weightForm.orderSn = item.orderSn;
            this.setWeightDialog = true;
        },
        setWeightSubmit(){
            this.is_post = true;
            let url = "order/first_weight";
            if(this.active_item.status == 26) {
                url = "order/second_weight";
            }
            request.post(url,this.weightForm).then(res=>{
                this.$message.success("模拟称重提交成功!");
                this.getData();
                this.setWeightDialog = false;
                this.is_post = false;
            }).catch(err=>{
                this.is_post = false;
            });
        },
        setLead(item){
            this.active_item = item;
            this.leadForm.orderSn = item.orderSn;
            this.setLeadDialog = true;
        },
        setLeadSubmit(){
            this.is_post = true;
            request.post("order/lead_seal",this.leadForm).then(res=>{
                this.$message.success("模拟铅封完成!");
                this.getData();
                this.setLeadDialog = false;
                this.is_post = false;
            }).catch(err=>{
                this.is_post = false;
            });
        },
        //物流公司
            querySearchExpressName(str,callback){
                  request.post("company/logistics_supplier_option",{type:2,keyword:str}).then(res=>{
                  if(res.data && res.data.length){
                        let arr = [];
                        for(let item of res.data){
                              arr.push({value:item.displayName});
                        }
                        callback(arr);
                  }
                  }).catch(err=>{
                  console.log(err);
                  });
            },
            //LNG挂牌价
            lngPrice(){
                  request.get('index/today_price').then(res=>{
                        if(res.code=='200'){
                              this.addForm.realPrice=res.data.todayPrice
                        }else{
                              this.$message.error('价格出现异常')
                        }
                  })
            },
            //保存
            addSubmit(){
                  //添加计划
                request.post('/order/client_create',this.addForm).then(res=>{
                    if(res.code=='200'){
                        this.add_dialog=false;
                        this.getData();
                        this.$message.success('计划单添加成功！')
                    }else{
                        this.$message.error('计划单失败！')
                    }
                })
            },
            //重置
            addSelect(){
                this.$refs['addForm'].resetFields()
            },
            //提交修改
            editSubmit(){
                this.$refs["addForm"].validate(valid=>{
                    if(!valid) return false;
                    this.is_post = true;
                    request.post("order/client_edit_info",this.addForm).then(res=>{
                        if(res.code==200){
                            this.$message.success('修改成功')
                            this.add_dialog=false;
                            this.is_add=true;
                            this.getData();
                        }
                    }).catch(err=>{
                        console.log(err);
                        this.is_post = false;
                    });
                });
            },
            close(){
                this.is_add=true;
                this.addForm={
                  carriageNumber:'',
                  expressName:'',
                  date:'',
                  driverMobile:'',
                  driverName:'',
                  plateNumber:"",
                  realPrice:'',
                  remark:""
               }
            }

    },
    created() {
        let time = new Date();
        this.dates.push(parseTime(time,"{y}-{m}-{d}"));
        time = time.getTime()+86400000;
        this.dates.push(parseTime(time,"{y}-{m}-{d}"));
        this.getcur();
    },
    mounted() {
        this.getData(true);
        this.getCompany();
    }
}
</script>

<style scoped lang="scss">

.order_item{
    margin-bottom: 20px;
    margin-right: 10px;

    &.active{
        background: rgb(217, 236, 255);
    }

    .item_body{
        min-height: 110px;
        padding: 20px;
        position: relative;

        .item_header{
            height: 20px;
            display: flex;
            align-items: center;
            line-height: 20px;
            width: 100%;

            .btns{
                position: absolute;
                top: -10px;
                right: -10px;

                .item_btn{
                    margin-left: 10px;
                    transition: all 0.5s;
                    cursor: pointer;
                    color: #67C23A;
                    background: transparent;
                    &:hover{
                        color: #fff;
                        background:#67C23A;
                        font-size: 1.1em;
                    }
                }
                .item_btn_cancel{
                    margin-left: 10px;
                    transition: all 0.5s;
                    cursor: pointer;
                    color: #cf4813;
                    background: transparent;
                    &:hover{
                        color: #fff;
                        background:#cf4813;
                        font-size: 1.1em;
                    }
                }
            }
        }

        .item_item{
            display: inline-block;
            margin-right: 30px;
            line-height: 30px;
            &.ptext{
                font-size: 16px;
            }
        }

    }

    .item_footer{
        height: 39px;
        border-top: 1px solid #ddd;
        line-height: 39px;
        font-size: 14px;
        padding: 0 20px;
    }

    .ptext{
        color: #666666;
        font-size: 14px;
    }
}
    .view_section_right_view {
        padding: 9px 0px;
        background: #1890ff;
        border-radius: 8px;
        margin-left: 78%;
        margin-bottom: 3%;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        display: flex;
        justify-content: center;
        font-weight: 400;
        color: #ffffff;
        width: 90px;
    }
    .flex{
        display: flex;
        justify-content: space-between;
    }
    .box{
        padding: 5%;
    }
    .textarea-box{
        width: 90%;
    }
    .remark-box{
        color: #9a9898
    }
    .btn-box{
        display: flex;
        justify-content: space-around;
        font-size: 18px;
    }
    .btn-common{
        width: 35%;
        padding: 10px;
        border-radius: 10px;
        text-align: center;
        margin-top: 15%;
    }
    .btn-reset{
        background:#DCDCDC;
    }
    .btn-identify{
        background:#658bef;
        color: #ffffff;
    }
    .box-title{
        font-size: 18px;
        margin-bottom: 3%;
    }
    .order-list{
        padding: 2%;
        margin: 2%;
        border-bottom: 2px solid #DCDCDC;
    }
    .order-text{
        padding: 12px 0;
        font-size: 16px;
        color: #696969;
    }
</style>
